/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowRuleDetailBase extends models.WorkFlowRuleBase {
    getFixupPrototypeFunction() { return WorkFlowRuleDetailBase.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowRuleDetailBase>): WorkFlowRuleDetailBase {
        let obj = Object.assign(new WorkFlowRuleDetailBase(), model);
        WorkFlowRuleDetailBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowRuleDetailBase>): WorkFlowRuleDetailBase {
        if (!model) return null;
        return WorkFlowRuleDetailBase.newInstance(<WorkFlowRuleDetailBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowRuleDetailBase) {
        if (!obj) return;

        models.WorkFlowRuleDetailBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowRuleDetailBase): boolean {
        if (models.WorkFlowRuleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkFlowRuleDetailBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Boolean to check whether the input has been override in the workflow
     */
    is_rule_override: boolean;

    /**
     * inputs with which the rules are getting scanned.
     */
    values: Array<string>;

}
